<script lang="ts" setup>
import VersionManagementTab from "@/views/shared/components/version-management/VersionManagementTab.vue";

interface Props {
  product: any;
  masterProjectId?: string;
}

const props = defineProps<Props>();
</script>

<template>
  <VersionManagementTab
    :product-id="product?.id ?? ''"
    :master-project-id="masterProjectId"
    entity-type="product"
  />
</template>
